/*ReactJS*/
import React from 'react';

/*Material UI Components*/
import { Typography, Breadcrumbs, Box } from '@material-ui/core';

/*Styles*/
import useStyles from '../../styles';

/*Table Components*/
import FractionalShareReconTable from './Components/FractionalShareReconTable';

export default function FractionalShareRecon(props) {
  const classes = useStyles();

  return (
    <React.Fragment>
      <div className={classes.pageContainer}>
        <Box>
          <Typography
            variant="h2"
            className={classes.textBold}
            align="left"
            gutterBottom={true}
          >
            Fractional Share Reconciliation
          </Typography>
          <Breadcrumbs aria-label="breadcrumb">
            <span color="inherit">Position</span>
            <Typography color="primary">
              Fractional Share Reconciliation
            </Typography>
          </Breadcrumbs>
        </Box>
        <Box mt={2}>
          <FractionalShareReconTable params={props} />
        </Box>
      </div>
    </React.Fragment>
  );
}
